import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../../animations/dogLoader.json'; // путь к твоему JSON-файлу

const LottieLoader = ({ width = 200, height = 200 }) => {
  return (
    <Lottie
      animationData={animationData}
      loop={true}
      style={{ width, height }}
    />
  );
};

export default LottieLoader;
